export enum ElementType {
    TEXT,
    IMAGE,
    HEADER,
    TEXT1,
    IMAGE1,
    HEADER1,
    LINE,
};

export interface HelpElement {
    elementType: ElementType,
    data: string,
};



export interface HelpBlockData {
    id?: string;
    title: string,
    elements: HelpElement[],
}


// WEBPACK FOOTER //
// ./src/help/helpTypes.ts